import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {
		padding: 16,
	},
});
